export const extractError = (error) => {
  if (error.response) {
    return {
      status: error.response.status,
      message: error.response.data ? error.response.data.message : 'Oops! Something went wrong!',
    };
  }
  return {
    message: error.message,
  };
};



// WEBPACK FOOTER //
// ./src/utils/error.js